<template>
  <v-layout class="auth-wrapper">
    <v-row class="fill-height" justify="center" no-gutters>
      <v-col cols="12" sm="5" md="4" xl="3">
        <div class="d-flex flex-column fill-height align-center justify-center">
          <v-img
            :src="require('@/assets/logotype-white.png')"
            max-width="16rem"
            max-height="3rem"
            contain
          />
        </div>
      </v-col>

      <v-col cols="12" sm="7" md="8" xl="9">
        <v-card class="card route-card" color="neutral" height="100%">
          <router-view />
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style lang="scss" src="./style.scss" scoped />
